import React, { useEffect } from 'react';
import { initFBPixel, trackPageView } from './utils/fbPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { HookSection } from './components/HookSection';
import { PainSection } from './components/PainSection';
import { RevelationSection } from './components/RevelationSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ResultsGridSection } from './components/ResultsGridSection';
import { OfferSection } from './components/OfferSection';
import { FaqSection } from './components/FaqSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { ValueStackSection } from './components/ValueStackSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
const PIXEL_ID = '2146772642750880';
export function App() {
  useEffect(() => {
    initFBPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen text-gray-100 font-sans selection:bg-gold/30 selection:text-white" style={{
    backgroundColor: '#080808'
  }} data-id="element-0">
      <UrgencyBar data-id="element-1" />

      {/* Main content wrapper with padding for sticky header */}
      <main className="pt-14 sm:pt-16" data-id="element-2">
        <HeroSection data-id="element-3" />
        <HookSection data-id="element-4" />
        <PainSection data-id="element-5" />
        <RevelationSection data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <ResultsGridSection data-id="element-8" />
        <OfferSection data-id="element-9" />
        <FaqSection data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <ValueStackSection data-id="element-12" />
        <ClosingSection data-id="element-13" />
      </main>

      <Footer data-id="element-14" />
    </div>;
}